export const ROOM_BLOCKED_SECTOR_TYPE_IDS = [1, 7, 999] as const;

export function isRoomBlockedSectorType(sectorTypeId?: number | null): boolean {
    if (!Number.isFinite(sectorTypeId)) return false;
    return ROOM_BLOCKED_SECTOR_TYPE_IDS.includes(Number(sectorTypeId) as (typeof ROOM_BLOCKED_SECTOR_TYPE_IDS)[number]);
}

